import { ReactComponent as NotFoundIcon } from "./svg/iconNotFound.svg";

export const IconNotFound = () => {
  return <NotFoundIcon />;
};
